import Message from "./Message";
import React from "react";

/**
 * Class to display the queue position message.
 * TODO: This is supposed to be displayed statically at the bottom of the window,
 * over being a live update message in the chat window.
 */
export default class QueuePositionMessage extends Message {

    componentDidMount() {
        // Do nothing other than stopping the Message componentDidMount from executing.
    }
    render() {
        if (!this.props.payload?.text || !this.props.payload?.queuePosition) {
            return '';
        }
        return(
            <div className='queue-position__text' dangerouslySetInnerHTML={this.evaluateMarkdown(this.props.payload.text.replace('{queue_position}', this.props.payload.queuePosition))} />
        );
    }
}